module.exports = __webpack_public_path__ + "static/media/zr_2_18.4d2fb298.png";